<h1 mat-dialog-title>{{"newOrder.confirmExit.title"| translate}}</h1>
<div mat-dialog-content>
    <h2>{{"newOrder.confirmExit.message" | translate}}</h2>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="cancel()" class="action-button">{{"common.buttons.cancel" | translate}}</button>
    <button mat-flat-button color="primary" (click)="discardAndGoToHome()" class="action-button">{{"newOrder.confirmExit.discard" | translate}}</button>
    <button mat-flat-button color="primary" (click)="saveAndGoToHome()" class="action-button">{{"newOrder.confirmExit.saveDraft" | translate}}</button>
</div>